export const translations = {
  en: {
    // Header
    home: 'Home',
    register: 'Register',
    faq: 'FAQ',
    adminLogin: 'Admin Login',
    
    // Hero Section
    heroTitle: 'Community Assisted Policing Through Use of Recorded Evidence',
    heroSubtitle: 'You can help protect your property, your family and your community by registering your security camera(s) with the Manitoba RCMP Rural Capture Program.',
    heroDescription: 'By registering your camera, you are taking an active role in deterring crime and assisting the RCMP with their overall crime prevention goals in your community.',
    registerNow: 'Register Now',
    
    // Benefits Section
    whyRegister: 'Why should I register my security camera?',
    secureTitle: 'Privacy and security',
    secureDesc: 'Your information is kept confidential and stored on secure Canadian servers',
    solveCrimeTitle: 'Solve Crime',
    solveCrimeDesc: 'Help RCMP quickly identify camera owners near crime scenes to assist investigations',
    freeEasyTitle: 'Free & Easy',
    freeEasyDesc: 'Quick registration process, completely free with no obligations',
    
    // Registration Section
    registrationEasy: 'Registration is easy',
    registrationDesc: 'Create an account and add your security camera details.',
    
    // Questions Section
    questions: 'Questions?',
    questionsDesc: 'Do you have questions regarding the program?',
    checkFaq: 'Check out the frequently asked questions for more information',
    
    // Footer
    footerText: 'This project is provided by the Manitoba RCMP.',
    getInTouch: 'Get in touch via',
    email: 'email',
    
    // Registration Form
    createAccount: 'Create Your Account',
    personalInfo: 'Personal Information',
    firstName: 'First Name',
    lastName: 'Last Name',
    emailAddress: 'Email Address',
    phone: 'Phone Number',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    
    addressInfo: 'Address Information',
    streetAddress: 'Street Address',
    city: 'City',
    province: 'Province',
    postalCode: 'Postal Code',
    nearestDetachment: 'Nearest RCMP Detachment',
    selectDetachment: 'Select a detachment...',
    detachmentRequired: 'Please select your nearest RCMP detachment',
    
    cameraInfo: 'Camera Information',
    numberOfCameras: 'Number of Cameras',
    cameraBrand: 'Camera Brand/Model',
    cameraLocation: 'Camera Location Description',
    coverageArea: 'Coverage Area (describe what the camera sees)',
    
    consent: 'Consent',
    consentText: 'I consent to the RCMP contacting me to request access to my security camera footage for investigative purposes. I understand that I maintain full control of my footage and can withdraw consent at any time.',
    agreeTerms: 'I agree to the terms and conditions',
    
    submit: 'Submit Registration',
    submitting: 'Submitting...',
    
    // FAQ Page
    faqTitle: 'Frequently Asked Questions',
    faq1Q: 'What is the Manitoba RCMP Rural Capture Program?',
    faq1A: 'The Rural Capture Program is a voluntary camera registry that allows residents and businesses to register their security cameras with the RCMP. This helps police quickly identify camera owners near crime scenes and request footage that may assist investigations.',
    faq2Q: 'Is registration mandatory?',
    faq2A: 'No, registration is completely voluntary. You can register or remove your registration at any time.',
    faq3Q: 'Do police have access to my live camera feed?',
    faq3A: 'No. The RCMP does not have access to your live feed or recorded footage. Officers will only contact you to request access to specific footage relevant to an investigation, and you can choose whether to provide it.',
    faq4Q: 'What information is collected?',
    faq4A: 'We collect your contact information, property address, number of cameras, and general camera coverage area. This information is kept confidential and stored on secure Canadian servers.',
    faq5Q: 'Can I register indoor cameras?',
    faq5A: 'Yes, if your indoor camera captures outdoor views that may be useful for investigations (such as a camera pointing at a window overlooking a driveway).',
    faq6Q: 'How will RCMP contact me?',
    faq6A: 'If footage from your camera may assist an investigation, an RCMP officer will contact you by phone or email to request access to specific footage from a particular date and time.',
    faq7Q: 'Can I remove my registration?',
    faq7A: 'Yes, you can contact us at any time to remove your registration from the program.',
    faq8Q: 'Is there a cost?',
    faq8A: 'No, the program is completely free to join and use.',
    
    // Admin Login
    adminLoginTitle: 'Admin Login',
    adminLoginDesc: 'Access the administrative dashboard',
    loginButton: 'Login',
    loggingIn: 'Logging in...',
    
    // Admin Dashboard
    dashboard: 'Dashboard',
    totalRegistrations: 'Total Registrations',
    totalCameras: 'Total Cameras',
    recentRegistrations: 'Recent Registrations',
    allRegistrations: 'All Registrations',
    exportData: 'Export Data',
    logout: 'Logout',
    viewDetails: 'View Details',
    registeredOn: 'Registered on',
    cameras: 'cameras',
    search: 'Search...',
    name: 'Name',
    location: 'Location',
    contact: 'Contact',
    actions: 'Actions',
    
    // Admin Dashboard - New features
    tableView: 'Table View',
    mapView: 'Map View',
    filterByStatus: 'Filter by Status',
    filterByPropertyType: 'Filter by Property Type',
    filterByMunicipality: 'Filter by Municipality',
    allStatuses: 'All Statuses',
    allPropertyTypes: 'All Property Types',
    allMunicipalities: 'All Municipalities',
    status: 'Status',
    propertyType: 'Property Type',
    municipality: 'Municipality',
    updateStatus: 'Update Status',
    statusNew: 'New',
    statusReviewed: 'Reviewed',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    residential: 'Residential',
    commercial: 'Commercial',
    farm: 'Farm',
    acreage: 'Acreage',
    clearFilters: 'Clear Filters',
    noRegistrationsFound: 'No registrations found',
    registrationsWithLocation: 'With Location',
    statusUpdated: 'Status Updated',
    statusUpdateFailed: 'Failed to update status',
    filterByDetachment: 'Filter by Detachment',
    allDetachments: 'All Detachments',
    
    // Admin Management
    adminManagement: 'Admin Management',
    adminAccounts: 'Admin Accounts',
    addAdmin: 'Add Admin',
    createNewAdmin: 'Create New Admin',
    adminEmail: 'Admin Email',
    adminPassword: 'Admin Password',
    confirmAdminPassword: 'Confirm Password',
    createAdmin: 'Create Admin',
    deleteAdmin: 'Delete Admin',
    changePassword: 'Change Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    updatePassword: 'Update Password',
    adminCreated: 'Admin account created successfully',
    adminDeleted: 'Admin account deleted successfully',
    passwordChanged: 'Password changed successfully',
    cannotDeleteSelf: 'Cannot delete your own account',
    cannotDeleteLast: 'Cannot delete the last admin account',
    passwordMismatch: 'Passwords do not match',
    passwordTooShort: 'Password must be at least 8 characters',
    adminExists: 'Admin with this email already exists',
    role: 'Role',
    createdDate: 'Created Date',
    noAdminsFound: 'No admin accounts found',
    
    // Disclaimer Page
    disclaimer: 'Disclaimer',
    disclaimerTitle: 'Disclaimer and Terms of Use',
    disclaimerSubtitle: 'Please read these terms carefully before registering',
    disclaimerGoal: 'Program Goals and Terms',
    disclaimerIntro: 'The goal of the Manitoba RCMP Security Camera Registry program is to deter crime and promote public safety through collaboration between the RCMP and the communities we serve. Accordingly, all Security Camera registrants agree to the following terms and conditions:',
    disclaimerTerm1: 'The RCMP may request access to video footage containing or related to criminal activity, that was collected by the home or business owner, for use in investigating criminal activity or for use as evidence during any stage of a criminal proceeding. When requested, the home or business owner may decide to disclose the requested video footage to the RCMP.',
    disclaimerTerm2: 'If necessary, the RCMP will contact the home or business owner directly, using the information provided on this site, to request the appropriate video surveillance footage.',
    disclaimerTerm3: 'Under no circumstances shall registrants construe that they are acting as an agent and/or employee of the RCMP through the Security Camera Registry program.',
    disclaimerTerm4: 'Under no circumstances shall the RCMP obtain any information or footage/feeds without the direct assistance from the registrants.',
    importantNotice: 'Important Notice',
    disclaimerNotice: 'By registering your security camera with this program, you acknowledge that you have read, understood, and agree to abide by these terms and conditions. Your participation is voluntary and you may withdraw at any time.',
    lastModified: 'Date modified',
    disclaimerContact: 'If you have any questions about these terms, please contact us at',

    // Public-information advisories (CAPTURE program)
    emergencyNoticeTitle: 'Important: reporting crimes and emergencies',
    emergencyNotice: 'This website is for security camera registration, not for reporting crimes or emergencies. In an emergency, call 911. For non-emergency crime reporting, contact your local police service.',
    supportHeading: 'Program support',
    supportPrompt: 'Questions about the CAPTURE program or your registration?',
    supportEmailLabel: 'Email',
    supportEmailDoNotReport: 'Do not use this email to report crimes or emergencies.',
  },
  fr: {
    // Header
    home: 'Accueil',
    register: "S'inscrire",
    faq: 'FAQ',
    adminLogin: 'Connexion Admin',
    
    // Hero Section
    heroTitle: 'Assistance Policière Communautaire par l\'Utilisation de Preuves Enregistrées',
    heroSubtitle: 'Vous pouvez aider à protéger votre propriété, votre famille et votre communauté en enregistrant votre(vos) caméra(s) de surveillance auprès du Programme Rural Capture de la GRC du Manitoba.',
    heroDescription: 'En enregistrant votre caméra, vous jouez un rôle actif dans la dissuasion de la criminalité et aidez la GRC à atteindre ses objectifs globaux de prévention du crime dans votre communauté.',
    registerNow: 'Inscrivez-vous Maintenant',
    
    // Benefits Section
    whyRegister: 'Pourquoi devrais-je enregistrer ma caméra de surveillance?',
    secureTitle: 'Confidentialité et sécurité',
    secureDesc: 'Vos informations sont gardées confidentielles et stockées sur des serveurs canadiens sécurisés',
    solveCrimeTitle: 'Résoudre les Crimes',
    solveCrimeDesc: 'Aidez la GRC à identifier rapidement les propriétaires de caméras près des scènes de crime pour aider les enquêtes',
    freeEasyTitle: 'Gratuit et Facile',
    freeEasyDesc: 'Processus d\'inscription rapide, complètement gratuit sans aucune obligation',
    
    // Registration Section
    registrationEasy: 'L\'inscription est facile',
    registrationDesc: 'Créez un compte et ajoutez les détails de votre caméra de surveillance.',
    
    // Questions Section
    questions: 'Des Questions?',
    questionsDesc: 'Avez-vous des questions concernant le programme?',
    checkFaq: 'Consultez la foire aux questions pour plus d\'informations',
    
    // Footer
    footerText: 'Ce projet est fourni par la GRC du Manitoba.',
    getInTouch: 'Contactez-nous par',
    email: 'courriel',
    
    // Registration Form
    createAccount: 'Créer Votre Compte',
    personalInfo: 'Informations Personnelles',
    firstName: 'Prénom',
    lastName: 'Nom de Famille',
    emailAddress: 'Adresse Courriel',
    phone: 'Numéro de Téléphone',
    password: 'Mot de Passe',
    confirmPassword: 'Confirmer le Mot de Passe',
    
    addressInfo: 'Informations d\'Adresse',
    streetAddress: 'Adresse',
    city: 'Ville',
    province: 'Province',
    postalCode: 'Code Postal',
    nearestDetachment: 'Détachement de la GRC le plus proche',
    selectDetachment: 'Sélectionnez un détachement...',
    detachmentRequired: 'Veuillez sélectionner votre détachement de la GRC le plus proche',
    
    cameraInfo: 'Informations sur la Caméra',
    numberOfCameras: 'Nombre de Caméras',
    cameraBrand: 'Marque/Modèle de la Caméra',
    cameraLocation: 'Description de l\'Emplacement de la Caméra',
    coverageArea: 'Zone de Couverture (décrivez ce que la caméra voit)',
    
    consent: 'Consentement',
    consentText: 'Je consens à ce que la GRC me contacte pour demander l\'accès aux images de ma caméra de surveillance à des fins d\'enquête. Je comprends que je garde le contrôle total de mes images et que je peux retirer mon consentement à tout moment.',
    agreeTerms: 'J\'accepte les termes et conditions',
    
    submit: 'Soumettre l\'Inscription',
    submitting: 'Soumission en cours...',
    
    // FAQ Page
    faqTitle: 'Questions Fréquemment Posées',
    faq1Q: 'Qu\'est-ce que le Programme Rural Capture de la GRC du Manitoba?',
    faq1A: 'Le Programme Rural Capture est un registre volontaire de caméras qui permet aux résidents et aux entreprises d\'enregistrer leurs caméras de surveillance auprès de la GRC. Cela aide la police à identifier rapidement les propriétaires de caméras près des scènes de crime et à demander des images qui peuvent aider les enquêtes.',
    faq2Q: 'L\'inscription est-elle obligatoire?',
    faq2A: 'Non, l\'inscription est complètement volontaire. Vous pouvez vous inscrire ou retirer votre inscription à tout moment.',
    faq3Q: 'La police a-t-elle accès à mon flux de caméra en direct?',
    faq3A: 'Non. La GRC n\'a pas accès à votre flux en direct ou aux images enregistrées. Les agents vous contacteront uniquement pour demander l\'accès à des images spécifiques pertinentes à une enquête, et vous pouvez choisir de les fournir ou non.',
    faq4Q: 'Quelles informations sont collectées?',
    faq4A: 'Nous collectons vos coordonnées, l\'adresse de votre propriété, le nombre de caméras et la zone de couverture générale des caméras. Ces informations sont gardées confidentielles et stockées sur des serveurs canadiens sécurisés.',
    faq5Q: 'Puis-je enregistrer des caméras intérieures?',
    faq5A: 'Oui, si votre caméra intérieure capture des vues extérieures qui peuvent être utiles pour les enquêtes (comme une caméra pointant vers une fenêtre donnant sur une allée).',
    faq6Q: 'Comment la GRC me contactera-t-elle?',
    faq6A: 'Si les images de votre caméra peuvent aider une enquête, un agent de la GRC vous contactera par téléphone ou courriel pour demander l\'accès à des images spécifiques d\'une date et d\'une heure particulières.',
    faq7Q: 'Puis-je retirer mon inscription?',
    faq7A: 'Oui, vous pouvez nous contacter à tout moment pour retirer votre inscription du programme.',
    faq8Q: 'Y a-t-il un coût?',
    faq8A: 'Non, le programme est complètement gratuit pour s\'inscrire et utiliser.',
    
    // Admin Login
    adminLoginTitle: 'Connexion Administrateur',
    adminLoginDesc: 'Accéder au tableau de bord administratif',
    loginButton: 'Se Connecter',
    loggingIn: 'Connexion en cours...',
    
    // Admin Dashboard
    dashboard: 'Tableau de Bord',
    totalRegistrations: 'Total des Inscriptions',
    totalCameras: 'Total des Caméras',
    recentRegistrations: 'Inscriptions Récentes',
    allRegistrations: 'Toutes les Inscriptions',
    exportData: 'Exporter les Données',
    logout: 'Déconnexion',
    viewDetails: 'Voir les Détails',
    registeredOn: 'Inscrit le',
    cameras: 'caméras',
    search: 'Rechercher...',
    name: 'Nom',
    location: 'Emplacement',
    contact: 'Contact',
    actions: 'Actions',
    
    // Admin Dashboard - New features
    tableView: 'Vue Tableau',
    mapView: 'Vue Carte',
    filterByStatus: 'Filtrer par Statut',
    filterByPropertyType: 'Filtrer par Type de Propriété',
    filterByMunicipality: 'Filtrer par Municipalité',
    allStatuses: 'Tous les Statuts',
    allPropertyTypes: 'Tous les Types',
    allMunicipalities: 'Toutes les Municipalités',
    status: 'Statut',
    propertyType: 'Type de Propriété',
    municipality: 'Municipalité',
    updateStatus: 'Mettre à jour le Statut',
    statusNew: 'Nouveau',
    statusReviewed: 'Examiné',
    statusActive: 'Actif',
    statusInactive: 'Inactif',
    residential: 'Résidentiel',
    commercial: 'Commercial',
    farm: 'Ferme',
    acreage: 'Terrain',
    clearFilters: 'Effacer les Filtres',
    noRegistrationsFound: 'Aucune inscription trouvée',
    registrationsWithLocation: 'Avec Emplacement',
    statusUpdated: 'Statut Mis à Jour',
    statusUpdateFailed: 'Échec de la mise à jour du statut',
    filterByDetachment: 'Filtrer par Détachement',
    allDetachments: 'Tous les Détachements',
    
    // Admin Management
    adminManagement: 'Gestion des Administrateurs',
    adminAccounts: 'Comptes Administrateurs',
    addAdmin: 'Ajouter un Admin',
    createNewAdmin: 'Créer un Nouvel Admin',
    adminEmail: 'Courriel Admin',
    adminPassword: 'Mot de Passe Admin',
    confirmAdminPassword: 'Confirmer le Mot de Passe',
    createAdmin: 'Créer Admin',
    deleteAdmin: 'Supprimer Admin',
    changePassword: 'Changer le Mot de Passe',
    newPassword: 'Nouveau Mot de Passe',
    confirmNewPassword: 'Confirmer le Nouveau Mot de Passe',
    updatePassword: 'Mettre à Jour le Mot de Passe',
    adminCreated: 'Compte administrateur créé avec succès',
    adminDeleted: 'Compte administrateur supprimé avec succès',
    passwordChanged: 'Mot de passe changé avec succès',
    cannotDeleteSelf: 'Impossible de supprimer votre propre compte',
    cannotDeleteLast: 'Impossible de supprimer le dernier compte administrateur',
    passwordMismatch: 'Les mots de passe ne correspondent pas',
    passwordTooShort: 'Le mot de passe doit contenir au moins 8 caractères',
    adminExists: 'Un administrateur avec ce courriel existe déjà',
    role: 'Rôle',
    createdDate: 'Date de Création',
    noAdminsFound: 'Aucun compte administrateur trouvé',
    
    // Disclaimer Page
    disclaimer: 'Avis de non-responsabilité',
    disclaimerTitle: 'Avis de non-responsabilité et conditions d\'utilisation',
    disclaimerSubtitle: 'Veuillez lire attentivement ces conditions avant de vous inscrire',
    disclaimerGoal: 'Objectifs et conditions du programme',
    disclaimerIntro: 'L\'objectif du programme de registre des caméras de surveillance de la GRC du Manitoba est de dissuader la criminalité et de promouvoir la sécurité publique grâce à la collaboration entre la GRC et les communautés que nous servons. En conséquence, tous les inscrits au registre des caméras de surveillance acceptent les conditions suivantes:',
    disclaimerTerm1: 'La GRC peut demander l\'accès aux images vidéo contenant ou liées à une activité criminelle, qui ont été recueillies par le propriétaire de la maison ou de l\'entreprise, pour les utiliser dans l\'enquête sur une activité criminelle ou comme preuve à tout stade d\'une procédure pénale. Sur demande, le propriétaire de la maison ou de l\'entreprise peut décider de divulguer les images vidéo demandées à la GRC.',
    disclaimerTerm2: 'Si nécessaire, la GRC contactera directement le propriétaire de la maison ou de l\'entreprise, en utilisant les informations fournies sur ce site, pour demander les images de vidéosurveillance appropriées.',
    disclaimerTerm3: 'En aucun cas, les inscrits ne doivent interpréter qu\'ils agissent en tant qu\'agent et/ou employé de la GRC dans le cadre du programme de registre des caméras de surveillance.',
    disclaimerTerm4: 'En aucun cas, la GRC n\'obtiendra d\'informations ou d\'images/flux sans l\'assistance directe des inscrits.',
    importantNotice: 'Avis important',
    disclaimerNotice: 'En inscrivant votre caméra de surveillance à ce programme, vous reconnaissez avoir lu, compris et accepté de respecter ces conditions. Votre participation est volontaire et vous pouvez vous retirer à tout moment.',
    lastModified: 'Date de modification',
    disclaimerContact: 'Si vous avez des questions concernant ces conditions, veuillez nous contacter à',

    // Public-information advisories (CAPTURE program)
    emergencyNoticeTitle: 'Important : signaler les crimes et les urgences',
    emergencyNotice: 'Ce site Web sert à l\'inscription de caméras de surveillance, et non au signalement de crimes ou de situations d\'urgence. En cas d\'urgence, composez le 911. Pour signaler un crime qui ne constitue pas une urgence, communiquez avec votre service de police local.',
    supportHeading: 'Soutien du programme',
    supportPrompt: 'Vous avez des questions sur le programme CAPTURE ou votre inscription?',
    supportEmailLabel: 'Écrivez à',
    supportEmailDoNotReport: 'N\'utilisez pas cette adresse pour signaler un crime ou une situation d\'urgence.',
  }
};

export const t = (key, language = 'en') => {
  return translations[language][key] || key;
};